import { render, staticRenderFns } from "./add-to-cart-standalone-multiple.vue?vue&type=template&id=5209a12a"
import script from "./add-to-cart-standalone-multiple.vue?vue&type=script&lang=js"
export * from "./add-to-cart-standalone-multiple.vue?vue&type=script&lang=js"
import style0 from "./add-to-cart-standalone-multiple.vue?vue&type=style&index=0&id=5209a12a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports